import { useState } from 'react';
import MeasurementUnits from '../../Layout/MeasurementUnits';
import { Loader } from '@front-activerse/common-components';
import { useAppContext } from '@front-activerse/common-components';

const CookbookIngredientReplacement = ({
  id,
  name,
  measurements,
  multiplier,
  replaceIngredient,
  originalIngredientId,
  dishId,
  ingredientKey,
  closeCollapse,
}) => {
  const [preloadInside, setPreloadInside] = useState(false);

  const {
    images: { iconChangeActive },
  } = useAppContext();

  const changeIngredient = async (event) => {
    if (event) {
      event.stopPropagation();
    }

    setPreloadInside(true);
    const response = await replaceIngredient.replace(
      dishId,
      originalIngredientId,
      id,
      ingredientKey,
      name,
      measurements
    );
    setPreloadInside(false);

    if (response.data.cookbook.replaceIngredient.__typename === 'BasicMutationSuccess') {
      closeCollapse();
    }
  };

  return (
    <>
      <li onClick={changeIngredient}>
        <MeasurementUnits measurements={measurements} multiplier={multiplier} />
        <span className="stay-together">
          <button type="button" className="btn-change">
            <img className="img-fluid" src={iconChangeActive} alt="" />
          </button>
        </span>
        {name}
      </li>
      {preloadInside ? <Loader fixed="no" /> : ''}
    </>
  );
};

export default CookbookIngredientReplacement;
